"use client"

import Avatar from "@/app/components/Avatar"
import Link from "next/link"
import { Blog } from "@types"
import { SubscribeButtonInline } from "./SubscribeButtonInline"
import { PublicUser } from "@/types/users"
import { AuthorDisplay } from "@/app/(app)/(blog)/components/rail/Authors"

export default function SmallPublicationRow({
  blog,
  imageUrl,
  title,
  subtitle,
  url,
  isUserSubscribed,
  isUserLoggedIn,
  onSubscribeCallback,
  delay,
  authors,
}: {
  blog: Pick<Blog, "id" | "lowercase_url">
  imageUrl: string
  title: string
  subtitle: string
  url: string
  isUserSubscribed: boolean
  isUserLoggedIn: boolean
  onSubscribeCallback: (blogId: string) => void
  delay?: number
  authors: PublicUser[]
}) {
  return (
    <div className="flex items-center justify-between">
      <Link
        href={url}
        className="flex items-center space-x-3 flex-grow"
        target="_blank"
        rel="noopener noreferrer"
        prefetch={false}
      >
        <Avatar src={imageUrl} alt={title} size={40} className="h-10 w-10" />
        <div>
          <p className="">{title}</p>
          <p className="text-sm text-gray-500">{subtitle}</p>
          <div onClick={(e) => e.preventDefault()}>
            <AuthorDisplay authors={authors} />
          </div>
        </div>
      </Link>

      <SubscribeButtonInline
        blog={blog}
        onSubscribeCallback={onSubscribeCallback}
        isUserSubscribed={isUserSubscribed}
        isUserLoggedIn={isUserLoggedIn}
        delay={delay}
      />
    </div>
  )
}
